import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import AppProviders from './app/providers/AppProviders';
import ClerkRuntimeProvider from './app/providers/ClerkRuntimeProvider';
import AppRouter from './app/router/AppRouter';
import AppShell from './shared/ui/layout/AppShell';
import RouteErrorBoundary from './shared/ui/errors/RouteErrorBoundary';

const App = () => {
  return (
    <Router>
      <ClerkRuntimeProvider>
        <RouteErrorBoundary routePath="__app_root__" feature="app" scope="root">
          <AppProviders>
            <AppShell>
              <AppRouter />
            </AppShell>
          </AppProviders>
        </RouteErrorBoundary>
      </ClerkRuntimeProvider>
    </Router>
  );
};

export default App;
